// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import { SiteDetailsFieldsFragment, PermissionsForSiteFragment } from './fragments.generated';
import { BuildFieldsFragment } from '../../build/shared/fragments.generated';
import gql from 'graphql-tag';
import { SiteDetailsFieldsFragmentDoc, PermissionsForSiteFragmentDoc } from './fragments.generated';
import { BuildFieldsFragmentDoc } from '../../build/shared/fragments.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ValidateSitePublicNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
  organizationId?: Types.Maybe<Types.Scalars['UUID']>;
  sourceOrganizationId?: Types.Maybe<Types.Scalars['String']>;
  sourceControlProvider?: Types.Maybe<Types.SourceControlProvider>;
  siteId?: Types.Maybe<Types.Scalars['UUID']>;
}>;


export type ValidateSitePublicNameQuery = (
  { __typename?: 'Query' }
  & { validateSitePublicName?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success'>
  )> }
);

export type BranchesForSiteQueryVariables = Types.Exact<{
  endCursor?: Types.Maybe<Types.Scalars['String']>;
  searchText?: Types.Maybe<Types.Scalars['String']>;
  siteId: Types.Scalars['UUID'];
}>;


export type BranchesForSiteQuery = (
  { __typename?: 'Query' }
  & { branchesForSite: (
    { __typename?: 'BranchListResults' }
    & Pick<Types.BranchListResults, 'branches'>
    & { pageInfo?: Types.Maybe<(
      { __typename?: 'GithubPagination' }
      & Pick<Types.GithubPagination, 'lastId' | 'hasNextPage'>
    )> }
  ) }
);

export type SiteDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type SiteDetailsQuery = (
  { __typename?: 'Query' }
  & { siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & SiteDetailsFieldsFragment
  )> }
);

export type SiteLatestBuildsQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type SiteLatestBuildsQuery = (
  { __typename?: 'Query' }
  & { siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id' | 'buildsEnabled' | 'previewBuildsEnabled'>
    & { latestBuild?: Types.Maybe<(
      { __typename?: 'Build' }
      & Pick<Types.Build, 'id' | 'buildStatus' | 'startedAt' | 'createdAt' | 'duration' | 'endedAt'>
    )>, latestPreview?: Types.Maybe<(
      { __typename?: 'Build' }
      & Pick<Types.Build, 'buildStatus'>
    )> }
  )> }
);

export type SiteChangedSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type SiteChangedSubscription = (
  { __typename?: 'Subscription' }
  & { siteChanged?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id' | 'previewStatus' | 'updatedAt' | 'previewBuildsEnabled' | 'buildsEnabled' | 'latestHostingDeployVersion' | 'manualHostingDeploysEnabled'>
    & { latestPreview?: Types.Maybe<(
      { __typename?: 'Build' }
      & Pick<Types.Build, 'buildStatus'>
    )>, latestBuild?: Types.Maybe<(
      { __typename?: 'Build' }
      & BuildFieldsFragment
    )> }
  )> }
);

export type SitePermissionsQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type SitePermissionsQuery = (
  { __typename?: 'Query' }
  & { siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id'>
    & { permissions?: Types.Maybe<(
      { __typename?: 'PermissionsDigest' }
      & PermissionsForSiteFragment
    )> }
  )> }
);


export const ValidateSitePublicNameDocument = gql`
    query ValidateSitePublicName($name: String!, $organizationId: UUID, $sourceOrganizationId: String, $sourceControlProvider: SourceControlProvider, $siteId: UUID) {
  validateSitePublicName(
    name: $name
    organizationId: $organizationId
    sourceOrganizationId: $sourceOrganizationId
    sourceControlProvider: $sourceControlProvider
    siteId: $siteId
  ) {
    success
  }
}
    `;

/**
 * __useValidateSitePublicNameQuery__
 *
 * To run a query within a React component, call `useValidateSitePublicNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSitePublicNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSitePublicNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      sourceOrganizationId: // value for 'sourceOrganizationId'
 *      sourceControlProvider: // value for 'sourceControlProvider'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useValidateSitePublicNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateSitePublicNameQuery, ValidateSitePublicNameQueryVariables>) {
        return ApolloReactHooks.useQuery<ValidateSitePublicNameQuery, ValidateSitePublicNameQueryVariables>(ValidateSitePublicNameDocument, baseOptions);
      }
export function useValidateSitePublicNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateSitePublicNameQuery, ValidateSitePublicNameQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ValidateSitePublicNameQuery, ValidateSitePublicNameQueryVariables>(ValidateSitePublicNameDocument, baseOptions);
        }
export type ValidateSitePublicNameQueryHookResult = ReturnType<typeof useValidateSitePublicNameQuery>;
export type ValidateSitePublicNameLazyQueryHookResult = ReturnType<typeof useValidateSitePublicNameLazyQuery>;
export type ValidateSitePublicNameQueryResult = ApolloReactCommon.QueryResult<ValidateSitePublicNameQuery, ValidateSitePublicNameQueryVariables>;
export const BranchesForSiteDocument = gql`
    query BranchesForSite($endCursor: String, $searchText: String, $siteId: UUID!) {
  branchesForSite(endCursor: $endCursor, searchText: $searchText, siteId: $siteId) {
    branches @connection(key: "branchesForSite")
    pageInfo {
      lastId
      hasNextPage
    }
  }
}
    `;

/**
 * __useBranchesForSiteQuery__
 *
 * To run a query within a React component, call `useBranchesForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchesForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchesForSiteQuery({
 *   variables: {
 *      endCursor: // value for 'endCursor'
 *      searchText: // value for 'searchText'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useBranchesForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BranchesForSiteQuery, BranchesForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<BranchesForSiteQuery, BranchesForSiteQueryVariables>(BranchesForSiteDocument, baseOptions);
      }
export function useBranchesForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BranchesForSiteQuery, BranchesForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BranchesForSiteQuery, BranchesForSiteQueryVariables>(BranchesForSiteDocument, baseOptions);
        }
export type BranchesForSiteQueryHookResult = ReturnType<typeof useBranchesForSiteQuery>;
export type BranchesForSiteLazyQueryHookResult = ReturnType<typeof useBranchesForSiteLazyQuery>;
export type BranchesForSiteQueryResult = ApolloReactCommon.QueryResult<BranchesForSiteQuery, BranchesForSiteQueryVariables>;
export const SiteDetailsDocument = gql`
    query SiteDetails($id: UUID!) {
  siteDetails(id: $id) {
    ...siteDetailsFields
  }
}
    ${SiteDetailsFieldsFragmentDoc}`;

/**
 * __useSiteDetailsQuery__
 *
 * To run a query within a React component, call `useSiteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteDetailsQuery, SiteDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<SiteDetailsQuery, SiteDetailsQueryVariables>(SiteDetailsDocument, baseOptions);
      }
export function useSiteDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteDetailsQuery, SiteDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SiteDetailsQuery, SiteDetailsQueryVariables>(SiteDetailsDocument, baseOptions);
        }
export type SiteDetailsQueryHookResult = ReturnType<typeof useSiteDetailsQuery>;
export type SiteDetailsLazyQueryHookResult = ReturnType<typeof useSiteDetailsLazyQuery>;
export type SiteDetailsQueryResult = ApolloReactCommon.QueryResult<SiteDetailsQuery, SiteDetailsQueryVariables>;
export const SiteLatestBuildsDocument = gql`
    query SiteLatestBuilds($id: UUID!) {
  siteDetails(id: $id) {
    id
    buildsEnabled
    previewBuildsEnabled
    latestBuild {
      id
      buildStatus
      startedAt
      createdAt
      duration
      endedAt
    }
    latestPreview {
      buildStatus
    }
  }
}
    `;

/**
 * __useSiteLatestBuildsQuery__
 *
 * To run a query within a React component, call `useSiteLatestBuildsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLatestBuildsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLatestBuildsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteLatestBuildsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SiteLatestBuildsQuery, SiteLatestBuildsQueryVariables>) {
        return ApolloReactHooks.useQuery<SiteLatestBuildsQuery, SiteLatestBuildsQueryVariables>(SiteLatestBuildsDocument, baseOptions);
      }
export function useSiteLatestBuildsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SiteLatestBuildsQuery, SiteLatestBuildsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SiteLatestBuildsQuery, SiteLatestBuildsQueryVariables>(SiteLatestBuildsDocument, baseOptions);
        }
export type SiteLatestBuildsQueryHookResult = ReturnType<typeof useSiteLatestBuildsQuery>;
export type SiteLatestBuildsLazyQueryHookResult = ReturnType<typeof useSiteLatestBuildsLazyQuery>;
export type SiteLatestBuildsQueryResult = ApolloReactCommon.QueryResult<SiteLatestBuildsQuery, SiteLatestBuildsQueryVariables>;
export const SiteChangedDocument = gql`
    subscription siteChanged($id: UUID!) {
  siteChanged(id: $id) {
    id
    previewStatus
    updatedAt
    previewBuildsEnabled
    buildsEnabled
    latestPreview {
      buildStatus
    }
    latestBuild {
      ...buildFields
    }
    latestHostingDeployVersion
    manualHostingDeploysEnabled
  }
}
    ${BuildFieldsFragmentDoc}`;

/**
 * __useSiteChangedSubscription__
 *
 * To run a query within a React component, call `useSiteChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<SiteChangedSubscription, SiteChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<SiteChangedSubscription, SiteChangedSubscriptionVariables>(SiteChangedDocument, baseOptions);
      }
export type SiteChangedSubscriptionHookResult = ReturnType<typeof useSiteChangedSubscription>;
export type SiteChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<SiteChangedSubscription>;
export const SitePermissionsDocument = gql`
    query SitePermissions($id: UUID!) {
  siteDetails(id: $id) {
    id
    permissions {
      ...permissionsForSite
    }
  }
}
    ${PermissionsForSiteFragmentDoc}`;

/**
 * __useSitePermissionsQuery__
 *
 * To run a query within a React component, call `useSitePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSitePermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SitePermissionsQuery, SitePermissionsQueryVariables>) {
        return ApolloReactHooks.useQuery<SitePermissionsQuery, SitePermissionsQueryVariables>(SitePermissionsDocument, baseOptions);
      }
export function useSitePermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SitePermissionsQuery, SitePermissionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SitePermissionsQuery, SitePermissionsQueryVariables>(SitePermissionsDocument, baseOptions);
        }
export type SitePermissionsQueryHookResult = ReturnType<typeof useSitePermissionsQuery>;
export type SitePermissionsLazyQueryHookResult = ReturnType<typeof useSitePermissionsLazyQuery>;
export type SitePermissionsQueryResult = ApolloReactCommon.QueryResult<SitePermissionsQuery, SitePermissionsQueryVariables>;
